export const checkIfStatusChangeAllowed = (prev, next, sequence) => {
  if (!Object.prototype.hasOwnProperty.call(sequence, prev)) {
    return false;
  }
  if (sequence[prev].includes(next)) {
    return true;
  }
  return false;
};
